import axios from 'axios'
import { onSuccess, onError, beforeRequestSuccess, beforeRequestError } from '../interceptors'
import { API_DEFAULT_TIMEOUT_MS } from '@/utils/constants'

const webClient = axios.create({
  baseURL: process.env.FASTLY_WEB_API,
  timeout: API_DEFAULT_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json; charset=UTF-8'
  }
})

webClient.interceptors.request.use(beforeRequestSuccess, beforeRequestError)

webClient.interceptors.response.use(onSuccess, onError)

export let fastly = webClient



// WEBPACK FOOTER //
// ./src/api/web/fastly.js